import { createSelector } from 'reselect'

import { getProcesses } from 'partner360/features/landing/helpers/getProcesses'
import { ILandingProcessedPlanning } from 'partner360/models/landing/ILandingProcessedPlanning'

import { selectLandingState } from './selectLandingState'

export const selectLandingProcesses = createSelector(
  [selectLandingState],
  ({
    processedPlannings,
    selectedPlanning,
    selectedOffering,
    selectedCategory,
    selectedStatus,
  }) => {
    const processes = getProcesses({
      selectedOffering,
      selectedPlanningId: selectedPlanning.PlanningId,
      processedPlannings,
      selectedStatus,
      selectedCategory,
    })

    return processes.map((el) => {
      const {
        actions,
        status,
        deadline,
        completeness,
        finData,
        isOfferingActive,
        offering,
        ...other
      } = el

      return {
        ...other,
        offering,
        actions,
        status,
        deadline,
        completeness: completeness ? Math.round(completeness * 100) : 0,
        isOfferingActive: Boolean(isOfferingActive),
        finData: finData ? finData.ndp : null,
      } as ILandingProcessedPlanning
    })
  }
)
